import { shippingStandard } from "@/apis/apis";
import ShippingManagementBaseTable from "../BaseTable";

function MatrixStandardPage() {
  return (
    <ShippingManagementBaseTable
      apiURL={shippingStandard}
      label="Shipping Matrix Standard"
    />
  );
}

export default MatrixStandardPage;
